import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { AppTable } from "@/components";
import { TableColumn, TableFetchParams, Ticket } from "@/types";
import CustomerService from "@/services/Customer.Service";
import {
  formatResolutionTime,
  getFormattedDateTime,
  getTicketClass,
  getTicketStatus,
} from "@/utils/helpers";
import { useNavigate } from "react-router-dom";

export default function CustomerTickets(): React.JSX.Element {
  const navigate = useNavigate();

  const fetchData = async (
    params: TableFetchParams
  ): Promise<{ data: Ticket[]; total: number }> => {
    const res = await CustomerService.getTicketList({
      ...params,
      sortField: "updatedAt",
    });
    const data = res?.data?.data || [];
    console.log(data, "data");
    const total = res?.data?.total || 0;
    return { data, total };
  };

  const columns: TableColumn[] = [
    {
      header: "Ticket Number",
      accessor: "ticketId",
      sortable: true,
    },
    {
      header: "Creation Time",
      accessor: "createdAt",
      sortable: true,
      render: (row: Ticket) => (
        <span>{getFormattedDateTime(row.createdAt)}</span>
      ),
    },
    {
      header: "Ticket status",
      accessor: "status",
      render: (row: Ticket) => (
        <Chip
          size="small"
          label={getTicketStatus(row)}
          className={getTicketClass(row)}
        />
      ),
    },
    { header: "Subject", accessor: "subject" },
    { header: "Category", accessor: "category" },
    { header: "Ticket Source", accessor: "source" },
    {
      header: "Resolution Time",
      accessor: "resolutionTime",
      render: (row: Ticket) => (
        <span> {formatResolutionTime(row?.resolutionTime)} </span>
      ),
    },
    {
      header: "CSAT Score",
      accessor: "csatScore",
      render: (row: Ticket) => (
        <span className="text-green"> {row?.csat} </span>
      ),
    },
    {
      header: "FCR",
      accessor: "fcr",
      render: (row: Ticket) => <span className="text-green"> {row?.fcr} </span>,
    },
  ];

  const actions = [
    {
      label: "View Details",
      handleAction: (row: Ticket) => navigate(`/customer/tickets-details/${row.id}`),
    },
    {
      label: "Delete",
      handleAction: (row: any) => {
        console.log(row);
      },
    },
  ];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h2" sx={{ mt: 1.125 }}>
          Tickets
        </Typography>
      </Box>
      <Box sx={{ pt: 2 }}>
        <AppTable
          actions={actions}
          columns={columns}
          fetchData={fetchData}
          enableSelection={false}
        />
      </Box>
    </>
  );
}
